var map = {
	"./active-members.webp": 1351,
	"./data-compare.svg": 1352,
	"./first-depositers.webp": 1353,
	"./net-win.webp": 1354,
	"./new-members.webp": 1355,
	"./new-registrars.webp": 1356,
	"./temporary-2.svg": 1357,
	"./temporary.svg": 1358,
	"./total-members.webp": 1359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 615;